<template>
  <div v-if="unpublishedRv">
    <div class="bg-primary-50 py-10">
      <TContainer class="text-center">
        <TImage
          :src="image"
          class="mx-auto w-48 h-auto mb-6"
        />

        <THeading
          :level="3"
         
          class="justify-center mb-2"
        >
          {{ t('pages.error.title.rvUnpublished') }}
        </THeading>
        <p>{{ t('pages.error.body.rvUnpublished') }}</p>
      </TContainer>
    </div>

    <div class="py-8 space-y-8 md:py-12 md:space-y-12">
      <TContainer>
        <div class="flex items-center">
          <div class="grow">
            <THeading
              :level="4"
              tag="h2"
            >
              {{ t('pages.error.rvUnpublished.title') }}
            </THeading>
            <p>
              {{ t('pages.error.rvUnpublished.subtitle', { place: `${unpublishedRv.City}, ${unpublishedRv.State}` }) }}
            </p>
          </div>

          <div class="max-md:hidden">
            <TButton
              v-if="!isWebView"
              @click="goToSearch"
            >
              {{ t('pages.error.rvUnpublished.moreRvs') }}
            </TButton>
          </div>
        </div>
      </TContainer>

      <TContainer>
        <GeneralSimilarRvs
          :rv-id="unpublishedRv.RVId"
          :quantity="9"
        />
      </TContainer>

      <div
        v-if="!isWebView"
        class="text-center mt-20 md:hidden"
      >
        <TButton @click="goToSearch">
          {{ t('pages.error.rvUnpublished.moreRvs') }}
        </TButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { RvUnpublishedError } from '~/types'
import type { NuxtError } from '#app'

const props = defineProps<{
  error: NuxtError
}>()

const { t } = useI18n()
const { isWebView } = usePlatform()
const { $gis, $captureError } = useNuxtApp()

const { getStaticImage } = useImage()

const image = computed(() => getStaticImage({
  path: '/web/images/empty-rv.svg',
}))

const unpublishedRv = computed<RvUnpublishedError | undefined>(() => {
  if (!props.error?.data) {
    return undefined
  }

  return props.error.data as RvUnpublishedError
})

const { navigateToRvSearch } = useSearch()

async function goToSearch() {
  try {
    const location = await $gis('/Geocoding/Geocode', {
      query: {
        Address: [unpublishedRv.value?.City, unpublishedRv.value?.State].filter(Boolean).join(', '),
      },
    })

    await navigateToRvSearch({
      PlaceId: location.placeId ?? undefined,
    })
  }
  catch (error) {
    $captureError(error)
  }
}
</script>

<i18n src="~~/i18n/locales/common/pages/error.json" lang="json" />
